<template>
  <div
    :style="{ top: $route.name == 'store' ? '80px' : '20px', position:$route.name == 'store'?'sticky':'unset' }"
  >
    <div class="bg-white">
      <div v-if="giftCartItems.length > 0" class="cart-items-wrapper">
        <div class="container">
          <template v-for="(item, index) in giftCartItems">
            <cart-item :cart-item="item" :key="index" />
          </template>
        </div>
      </div>
      <hr v-if="giftCartItems.length > 0" />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">
              {{ $t("message.subtotal") }}
              <small class="fw-600">({{ cartLength }} items)</small>
            </div>
            <div class="cart-subtotal-cost">{{ giftCartValue | formatMoney }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="cart-subtotal-label">{{ $t("message.discount") }}</div>
            <div class="cart-subtotal-cost">{{ giftDiscount | formatMoney }}</div>
          </div>
        </div>
        <div
          v-show="
            giftCartItems.length > 0 &&
              giftCartValue > 0 &&
              $route.name == 'giftcardCheckout'
          "
          class="row"
        >
          <CouponComponent ref="couponComponent" :className="'cart-totals'"></CouponComponent>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals">
            <div class="total">{{ $t("message.total") }}</div>
            <div class="cost">{{ giftTotalPrice | formatMoney }}</div>
          </div>
        </div>
      </div>
      <div class="container" v-if="orderMode && currentStoreDoc.TermsAndConditions">
        <div class="d-flex privacy-policy">
          <div class="privacy-policy-checkbox">
            <Checkbox v-model="privacyPolicyCheckbox" :label="''"></Checkbox>
          </div>
          <div class="privacy-policy-link">
            I agree to
            <a
              :style="desktopStyles.LinkColorTxt"
              @click="openPrivacyPolicyModal()"
            >the terms and conditions</a>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="orderMode"
              :disabled="orderDisbaled"
              type="submit"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
            >
              {{ $t("message.placeOrder") }}
              <span v-show="proccessing">
                <i class="spin ml-4" />
              </span>
            </button>
            <router-link
              v-else
              :to="{
                name: 'giftcardCheckout',
                params: {
                  storeid: $route.params.storeid,
                  storename: $route.params.storename
                }
              }"
              :class="{
                disabled: giftCartItems.length === 0 ? 'disabled' : ''
              }"
              class="btn btn-primary btn-lg btn-block shadow mb-2"
            >{{ "Checkout" }}</router-link>
            <div v-show="!exceedMinPurchase" class="color-red pt-1 text-center">
              {{ $t("message.minimumPurchaseIs") }}
              {{ minPurchase | formatMoney }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >{{ $t("message.continueOrdering") }}</button>
    </div>

    <modal ref="privacyModal" v-if="showPrivacyModal" full-header @close="closePrivacyPolicyModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">Terms And Conditions</h2>
          </div>
          <p class="py-4 terms-and-conditions" v-html="currentStoreDoc.TermsAndConditions"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            @click="closePrivacyPolicyModal()"
          >{{ $t('message.ok') }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import CartItem from "./GiftCartItem";
import { getStore } from "../../../api/services/storeService.js";
import { DateTime } from "luxon";
import CouponComponent from "../../shop/shopping-cart/CouponComponent";
import Checkbox from "../../shared/checkbox";
import modal from "../../modal";
import $ from "jquery";
import { $$ } from "../../../sharedscripts/OO_jquery.js";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    CouponComponent,
    Checkbox,
    modal
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      store: {},

      timerId: null,
      deliveryFee: 0,
      minPurchase: 0,
      privacyPolicyCheckbox: false,
      showPrivacyModal: false
    };
  },
  computed: {
    ...mapGetters([
      "giftCartValue",
      "giftCartItems",
      "giftTotalPrice",
      "giftDiscount",
      "currentStoreDoc",
      "desktopStyles"
    ]),
    cartLength() {
      let sum = 0;
      this.giftCartItems.forEach(element => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    exceedMinPurchase() {
      return this.giftTotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local()
        .plus({ hours: 10 })
        .toUTC();
    },
    now() {
      return DateTime.local().toUTC();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.giftCartItems.length === 0 ||
        (!this.privacyPolicyCheckbox && this.currentStoreDoc.TermsAndConditions)
      );
    }
  },
  watch: {
    store() {
      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    giftTotalPrice() {
      this.computeRules(this.orderMode);
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...mapMutations(["REMOVE_GIFTCART_ITEM", "setDeliveryFee"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    changeSticky(mode) {
      if (mode) {
        var elem = $$("#uniquemodal");
        if (elem.length > 0) {
          elem
            .parent()
            .find("#uniquemodal")
            .remove();
          var cart = $$("#shopping-cart");
          cart.append(elem);
        }
      } else {
        elem = $$("#uniquemodal");
        if (elem.length > 0) {
          elem
            .parent()
            .find("#uniquemodal")
            .remove();
        }

        elem = $(".modal-backdrop.fade.show");
        if (elem.length > 0) {
          elem
            .parent()
            .find(".modal-backdrop.fade.show")
            .remove();
        }
      }
    },
    continueOrder() {
      this.$router.push({
        name: "giftstore",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.valueOf() > this.refreshTime.valueOf()) {
        this.giftCartItems.forEach(element => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.valueOf < this.refreshTime.valueOf()) {
            this.REMOVE_GIFTCART_ITEM({ item: element });
          }
        });
      }
    },
    computeRules() {
      //delivery fee
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            this.giftTotalPrice > rule.PriceRangeMinimum &&
            this.giftTotalPrice < rule.PriceRangeMaximum
          ) {
            this.deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }
      //this.setDeliveryFee(this.deliveryFee);
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    }
  }
};
</script>
